export default "__VITE_ASSET__94ff6c9a__"